var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-2"},[_c('Chrome',{style:({ width: '100%' }),attrs:{"value":_vm.editable},on:{"input":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }